import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import pl from 'vuetify/src/locale/pl';

Vue.use(Vuetify, {
  theme: {
    primary: '#2E7D32', // green darken-3
    secondary: '#2E7D32', // green darken-3
    tertiary: '#495057',
    accent: '#82B1FF',
    error: '#C62828', // red darken-3
    info: '#00d3ee',
    success: '#5cb860',
    warning: '#ffa21a'
  },
  iconfont: 'mdi',
  lang: {
    locales: { pl },
    current: 'pl'
  }
});
